var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',[_c('el-header',{attrs:{"height":"88px"}},[_c('HeaderNav',{attrs:{"curHash":'about'}})],1),_vm._v(" "),_c('el-main',{style:(("height:" + _vm.contentHeight + "; flex-grow:1; padding: 0"))}),_vm._v(" "),_c('el-footer',{attrs:{"height":"54px"}},[_c('Footer')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-132dad8c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/about.vue
// module id = null
// module chunks = 